import AppBridge from './bridge'
import UnityBridge from '@/h5/utils/appActions/unityBridge'
import { processJsonString } from '@/h5/utils/stringProcess'
/**
 * 设置页面标题
 * @param {*} title
 */
export const BridgeSetTitle = (title) => {
  document.title = title
  AppBridge({
    method: 'setTitle',
    data: {
      title
    },
    callBack: true,
    module: 'data'
  })
}

/**
 * 接口请求
 * @param {*} params
 * @returns
 */
export const requestUnityApi = (reqId, request) => {
  return new Promise((resolve, reject) => {
    const requestData = JSON.stringify(request)
    UnityBridge.callHandler(`h5Req&${JSON.stringify({ reqId, request: requestData })}`, (_, data) => {
      console.log('h5Req', _, data)
      if (_ === false || !data) {
        reject(new Error('h5Req error'))
      }
      try {
        const res = processJsonString(data)
        resolve({ data: res.response })
      } catch (error) {
        reject(error)
      }
    })
  })
}

export default {
  requestUnityApi
}
